import {
  JIRA_CUSTOM_FIELD_MODEL,
  TABLE_MODEL_JIRA_CUSTOM_FIELD
} from '../jiraStats.model';
import EstCostTooltip from './help/EstCostTooltip';

const useJiraCustomFieldCols = ({ raCost }) => {
  const cols = [
    {
      dataPoint: TABLE_MODEL_JIRA_CUSTOM_FIELD.NAME_CELL,
      name: 'NAME',
      sortPoint: JIRA_CUSTOM_FIELD_MODEL.NAME,
      isSortedCol: true
    },
    {
      dataPoint: TABLE_MODEL_JIRA_CUSTOM_FIELD.ASSIGNEES_CELL,
      name: 'ASSIGNEES'
    },
    {
      dataPoint: TABLE_MODEL_JIRA_CUSTOM_FIELD.JIRA_ISSUES_CELL,
      name: 'JIRA ISSUES',
      sortPoint: JIRA_CUSTOM_FIELD_MODEL.JIRA_ISSUES,
      isSortedCol: true
    },
    {
      dataPoint: TABLE_MODEL_JIRA_CUSTOM_FIELD.EFFORT_CELL,
      name: '% OF TOTAL WORK',
      sortPoint: JIRA_CUSTOM_FIELD_MODEL.EFFORT,
      isSortedCol: true
    },
    {
      dataPoint: TABLE_MODEL_JIRA_CUSTOM_FIELD.EFFORT_FTE_CELL,
      name: 'EFFORT (FTE)',
      sortPoint: JIRA_CUSTOM_FIELD_MODEL.EFFORT_FTE,
      isSortedCol: true
    },
    ...(raCost.isEnabled
      ? [
          {
            dataPoint: TABLE_MODEL_JIRA_CUSTOM_FIELD.COST_FTE_CELL,
            name: 'EST. COST BY FTE',
            sortPoint: JIRA_CUSTOM_FIELD_MODEL.EFFORT_FTE,
            isSortedCol: true,
            help: {
              tooltip: <EstCostTooltip />
            }
          }
        ]
      : [])
  ];
  return cols;
};

export default useJiraCustomFieldCols;
